import { render, staticRenderFns } from "./BookingPoliciesList.vue?vue&type=template&id=c4378e08&"
import script from "./BookingPoliciesList.vue?vue&type=script&lang=js&"
export * from "./BookingPoliciesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports